import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  adapter: 'fetch',
});

let redirectingAfterUnauthorized = false;

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && typeof window !== "undefined" && !redirectingAfterUnauthorized) {
      const requestPath = String(error.config?.url || "").split("?")[0];
      const currentPath = window.location.pathname;
      const portalRequest = requestPath.startsWith("/portal/");
      const publicPortalRequest = ["/portal/login", "/portal/forgot", "/portal/magic-login"].includes(requestPath)
        || requestPath.startsWith("/portal/password-reset/");
      const publicPortalPath = ["/portal/login", "/portal/forgot", "/portal/magic-login"].includes(currentPath);
      const publicAdminPath = currentPath === "/login" || currentPath === "/verify-otp";

      if (portalRequest && !publicPortalRequest && !publicPortalPath && currentPath.startsWith("/portal")) {
        redirectingAfterUnauthorized = true;
        window.location.replace("/portal/login?reason=session-expired");
      } else if (!portalRequest && !publicAdminPath && !currentPath.startsWith("/portal")) {
        redirectingAfterUnauthorized = true;
        try {
          sessionStorage.removeItem("hris_pending_2fa");
          sessionStorage.removeItem("hris_pending_totp");
        } catch {
          /* Ignore unavailable browser storage before redirecting. */
        }
        window.location.replace("/login?reason=session-expired");
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Terjadi kesalahan. Coba lagi.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function formatIDR(number) {
  if (number == null || isNaN(number)) return "Rp 0";
  return "Rp " + Math.round(number).toLocaleString("id-ID");
}
